import React, { useState, useEffect } from 'react';

import { InputAdornment } from '@material-ui/core';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import { format } from 'date-fns';
import { StyledTextField } from 'styles/common';

import { StyledIcon } from 'constants/icons';

export const DateField = ({ control: { id }, value, openDatePicker, loading }) => (
  <StyledTextField
    id={id}
    fullWidth
    variant="outlined"
    size="normal"
    margin="dense"
    name={id}
    value={value ? format(value, 'dd/MM/yyyy') : ''}
    placeholder="DD/MM/YYYY"
    disabled={loading}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <StyledIcon
            size="header"
            color="textSecondary"
            rightGutter={0.5}
            {...(!loading && { onClick: () => openDatePicker(id) })}
          >
            <DateRangeOutlinedIcon />
          </StyledIcon>
        </InputAdornment>
      ),
    }}
  />
);

export const TextField = ({ control: { id, title }, value, onBlur, loading }) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <StyledTextField
      id={id}
      fullWidth
      variant="outlined"
      size="normal"
      margin="dense"
      name={id}
      value={localValue}
      onChange={({ target }) => setLocalValue(target.value)}
      onBlur={() => onBlur(id, localValue)}
      placeholder={title}
      disabled={loading}
    />
  );
};

export const TextFieldWithValidation = ({
  control: { id, title },
  validationRegex,
  helperText,
  value,
  onBlur,
  loading,
}) => {
  const [localValue, setLocalValue] = useState(value);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    setError(!validationRegex.test(localValue));
  }, [localValue]);

  return (
    <StyledTextField
      error={error}
      helperText={error ? helperText : ''}
      id={id}
      fullWidth
      variant="outlined"
      size="normal"
      margin="dense"
      name={id}
      value={localValue}
      onChange={({ target }) => setLocalValue(target.value)}
      onBlur={() => onBlur(id, localValue)}
      placeholder={title}
      disabled={loading}
    />
  );
};
